import { Fragment, useRef } from "react";
import { useDispatch } from "react-redux";
import { Dialog, Transition } from "@headlessui/react";
import { AiOutlineCheck } from "react-icons/ai";

export default function CommunitySuccessModal({ open, setOpen, closeModal }) {
  const cancelButtonRef = useRef(null);
  const dispatch = useDispatch();

  const handleCloseModal = () => {
    dispatch(closeModal());
  };
  return (
    <>
      <Transition.Root show={open} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-10"
          initialFocus={cancelButtonRef}
          onClose={setOpen}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>
          <div className="fixed z-10 inset-0 overflow-y-auto">
            <div className="flex items-end sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="relative bg-white rounded-lg text-center overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-lg sm:w-full">
                  <div className="bg-white p-10">
                    <div>
                      <div className="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-green-100">
                        <AiOutlineCheck className="h-6 w-6 text-green-600" />
                      </div>
                      <div className="mt-3 text-center">
                        <h3
                          className="text-lg md:text-xl leading-6 font-medium text-gray-900 font-bold"
                          id="modal-title"
                        >
                          Community created successfully
                        </h3>
                        <div className="mt-4">
                          <p className="text-sm md:text-lg text-gray-500">
                            The host would have to accept your community request
                            before it goes live for everyone to see.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="mt-10 flex justify-center">
                      <button
                        onClick={() => handleCloseModal()}
                        type="button"
                        className="compass_color font-bold cursor-pointer border rounded-md px-3 py-2"
                      >
                        Close
                      </button>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    </>
  );
}
